import React, { useState } from 'react';
import './../../sass/page/_mission-vision.scss';
import { FaBullseye, FaEye } from 'react-icons/fa';
import missionImg from '../../images/mission.jpg';
import visionImg from '../../images/vision.jpg';
import defaultImg from '../../images/mv.jpg';

const MissionVision = () => {
    const [hoveredBlock, setHoveredBlock] = useState(null);

    return (
        <section id="mission-vision" className="mission-vision-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title">
                            <h2>Our Mission & Vision</h2>
                            <p>Driving innovation and excellence in everything we do</p>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-lg-5 col-12">
                        <div className="image-collage">
                            {hoveredBlock === 'mission' && (
                                <img src={missionImg} alt="Mission" className="hover-image" />
                            )}
                            {hoveredBlock === 'vision' && (
                                <img src={visionImg} alt="Vision" className="hover-image" />
                            )}
                            {!hoveredBlock && (
                                <img src={defaultImg} alt="Mission & Vision" className="hover-image" />
                            )}
                        </div>
                    </div>
                    <div className="col-lg-7 col-12">
                        <div className="mission-vision-content">
                            <div 
                                className={`vision-block ${hoveredBlock === 'vision' ? 'hovered' : ''}`}
                                onMouseEnter={() => setHoveredBlock('vision')}
                                onMouseLeave={() => setHoveredBlock(null)}
                            >
                                <div className="content-wrapper">
                                    <div className="text-content">
                                        <h3>Vision</h3>
                                        <p>To be recognized as a leading and reliable chemical supplier in India, known for integrity, quality, and strong partnerships across industries.</p>
                                    </div>
                                    <div className="icon-wrapper"><FaEye /></div>
                                </div>
                            </div>
                            <div 
                                className={`mission-block ${hoveredBlock === 'mission' ? 'hovered' : ''}`}
                                onMouseEnter={() => setHoveredBlock('mission')}
                                onMouseLeave={() => setHoveredBlock(null)}
                            >
                                <div className="content-wrapper">
                                    <div className="text-content">
                                        <h3>Mission</h3>
                                        <p>To supply high-quality chemical products that meet industry standards, while ensuring timely delivery, customer satisfaction, and continual improvement in our processes.</p>
                                    </div>
                                    <div className="icon-wrapper"><FaBullseye /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MissionVision;